import { useState } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router';
import { Edit } from '@mui/icons-material';

import theme from '@/constants/theme';
import Button from '@/components/input/Button';
import { routes } from '@/constants/routes';
import useLearningRoutes from '@/context/routes/hook';
import Tabs from '@/components/dataDisplay/Tabs';
import BackButton from '@/components/admin/BackButton';
import RouteStages from '@/components/admin/routes/RouteStages';

import RouteContents from '../../../components/admin/routes/RouteContents';
import UsersProgresses from '../../../components/admin/routes/RouteUsersProgresses';

import { styles } from './styles';

const RouteDetail = () => {
  const { routeId } = useParams();
  const { getRouteById } = useLearningRoutes();
  const navigate = useNavigate();
  const route = getRouteById(routeId!);
  const [currentTab, setCurrentTab] = useState(0);

  const handleEditRoute = () => {
    navigate(generatePath(routes.admin.routes.edit, { routeId }));
  };

  if (!route) return <p>No se encontro la ruta</p>;

  return (
    <div style={styles.container}>
      <BackButton href={generatePath(routes.admin.routes.root)}>Regresar a todas las rutas</BackButton>
      <img src={route?.coverImage} alt="cover" style={styles.cover} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: 16,
          color: theme.colors.text.caption,
        }}
      >
        <span style={styles.badge}>Orden {route?.order}</span>
        <span style={styles.badge}>{route?.type}</span>
      </div>
      <div style={{ display: 'flex', gap: 16, flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h1 style={{ color: theme.colors.text.title }}>{route?.title ?? 'Ruta no encontrada'}</h1>
          <Button variant="outline" Icon={Edit} onClick={handleEditRoute}>
            Editar Ruta
          </Button>
        </div>
        <p style={{ color: theme.colors.text.body }}>{route?.description ?? 'No description'}</p>
      </div>
      <Tabs
        tabs={[
          { id: 0, label: 'Contenidos' },
          { id: 1, label: 'Etapas' },
          { id: 2, label: 'Progreso de los usuarios' },
        ]}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
      {currentTab === 0 && <RouteContents routeId={routeId} />}
      {currentTab === 1 && <RouteStages routeId={routeId} />}
      {currentTab === 2 && <UsersProgresses routeId={routeId} />}
    </div>
  );
};

export default RouteDetail;
